import { render, staticRenderFns } from "./prakerja.vue?vue&type=template&id=8d37255c&scoped=true&"
import script from "./prakerja.vue?vue&type=script&lang=js&"
export * from "./prakerja.vue?vue&type=script&lang=js&"
import style0 from "./prakerja.vue?vue&type=style&index=0&id=8d37255c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d37255c",
  null
  
)

export default component.exports